import { ReactElement } from 'react';
import { PAGE_ICONS } from 'pages/AnnualUserAccessReview/_const';
import PageWithBreadcrumbs from 'pages/AnnualUserAccessReview/layouts/UARPageWithBreadcrumbs';
import EditUserProfile from './EditUserProfile';

/**
 * Page where manager can grant review privileges to another direct report
 * @returns {ReactElement} User Access Review Employee Delegate page view
 */
const EditView = () => {
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'Edit User Profile'}
			CurrentPageIcon={PAGE_ICONS.EDIT}
		>
			<EditUserProfile />
		</PageWithBreadcrumbs>
	);
};

export default EditView;
